import React from 'react';
import './style.css';

export default class ModalComponent extends React.Component {
    state = {
        animating: false,
    }

    closeModal = () => {
        this.setState({animating: true})
        setTimeout(() => {
            this.setState({animating: false});
            this.props.close();
        }, 250)
    }

    render() {
        if(!this.props.isActive)
            return null;

        let clases = ["modal"]

        if(this.state.animating)
            clases.push("animating")
        if(this.props.isActive)
            clases.push("is-active")

        return (
            <div className={clases.join(" ")}>
                <div className="modal-background"></div>
                {this.props.children}
                {this.props.hasClose &&
                <button onClick={this.closeModal} className="modal-close is-large" aria-label="close"></button>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modal/index.js